<template>
  <jt-card-default
    @filter-button="openDetailModal"
  >
    <div v-if="isLoading" class="div-loader">
      <div class="spinning-loader rotate"></div>
    </div>
    <jt-line-chart v-else
      centralTitleConst="Resíduos"
      :data="historyCollections"
      :xAxisData="columnsLineChart"
      :shouldTranslateXAxisData="true"
      :yAxisIndexNames="['Ton']"
    />
    <technology-dashboard-modal-filter
      v-bind="modalData"
      @submit="onChange"
      @change-visibility="(show) => (modalData.show = show)"
    />
  </jt-card-default>
</template>

<script>
import JtLineChart from 'src/components/charts/JtLineChart.vue'
import JtCardDefault from './base/JtCardDefault.vue'
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import TechnologyDashboardModalFilter from './base/TechnologyDashboardModalFilter.vue'
import lineGraphCommonMethods from 'src/components/charts/shared/lineGraphCommonMethods'
@Component({
  name: 'ResiduesByResidueAndTechnologyLineGraph',
  components: {
    JtCardDefault,
    JtLineChart,
    TechnologyDashboardModalFilter
  }
})
export default class ResiduesByResidueAndTechnologyLineGraph extends Vue {
  isLoading = false

  currentDate = {
    date: new Date()
  }

  modalData = {
    show: false
  }

  async openDetailModal () {
    this.modalData.show = true
  }

  columnsLineChart = []

  historyCollections = []

  async created () {
    await this.onChange(this.currentDate)
  }

  async onChange (date) {
    this.isLoading = true
    this.graphData = await this.getGraphData(date)
    const maxDay = lineGraphCommonMethods.getMaxValueAxisXLine(this.graphData)
    this.columnsLineChart = lineGraphCommonMethods.normalizeAxisXData(maxDay)
    const groupedDataByResidue = this.groupByResidue()
    const finalResult = []
    const resultNormalized = this.normalizeDataToLineGraph(groupedDataByResidue)
    resultNormalized.forEach(array => {
      const valores = array.map((register) => register.value)
      const name = array[0].residueName
      finalResult.push({ data: valores, name: name })
    })

    this.historyCollections = finalResult

    setTimeout(() => {
      this.isLoading = false
    }, 500)
  }

  normalizeDataToLineGraph (groupedDataByTechnology) {
    const resultNormalized = []
    groupedDataByTechnology.forEach(e => {
      resultNormalized.push(this.fillArrayWithZeroValues(e))
    })
    return resultNormalized
  }

  fillArrayWithZeroValues (inputArray) {
    const filledArray = []
    let currentLabel = 1

    inputArray.forEach(item => {
      while (currentLabel < item.label) {
        filledArray.push({
          label: currentLabel,
          value: '0',
          residueName: inputArray[0]?.residueName
        })
        currentLabel++
      }
      filledArray.push(item)
      currentLabel++
    })
    return filledArray
  }

  groupByResidue () {
    const groupedData = this.graphData.reduce((acc, item) => {
      if (!acc[item.residueName]) {
        acc[item.residueName] = []
      }
      acc[item.residueName].push(item)
      return acc
    }, {})
    return Object.values(groupedData)
  }

  async getGraphData (form) {
    const objectRequest = {
      month: form.date.getMonth() + 1,
      year: form.date.getFullYear(),
      composition: [{
        technologies: form.technologies,
        residues: form.residues
      }]
    }
    const { registros } = await repository.resolveLogic('technologyDashboard.searchResiduesGroupByTreatmentTypeAndResidue', { ...objectRequest })
    return registros.map((registro) => {
      return {
        label: registro.day,
        value: (registro.value / 1000).toFixed(2),
        residueName: registro.residueName
      }
    })
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

</style>
